import * as React from "react";
const SvgArrowChevronUp = props => <svg width="inherit" height="inherit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 16L12 7L21 16" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgArrowChevronUp;